(
    function (skyward, $)
    {
        "use strict";

        skyward.dataPath = skyward.dataPath || {};

        function init(selector)
        {
            $(selector).find(".dataObjectViewer").each(function ()
            {
                var dov = $(this);
                dov.on("keydown", "input,textarea,select", altF2Listener(dov.data("module"), dov.data("object")));
            });

            $(selector).find(".workflowContent").each(function ()
            {
                var workflowContent = $(this);
                var postData = { taskInstanceID: workflowContent.data("workflow-task-instance-id") };

                if (postData.taskInstanceID == undefined)
                {
                    return;
                }
                
                workflowContent.off("keydown.altF2Listener").on("keydown.altF2Listener", "input,textarea,select", altF2Listener("Workflow", "TaskInstance", postData));
            });
        }

        var altF2Listener = function (module, object, postData)
        {
            return function (event)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                if (!eventKeys.ALT || !eventKeys.F2)
                {
                    return;
                }

                var elem = $(this);
                var codeEELParent = elem.closest(".codeEEL");
                var dmseParent = elem.closest(".distinctMultiSelectEEL");

                var overrideElem;
                if (codeEELParent.length <= 0 && dmseParent.length <= 0)
                {
                    overrideElem = elem;
                }
                else
                {
                    overrideElem = codeEELParent.length > 0 ? codeEELParent : dmseParent;
                }

                var override =
                {
                    module: overrideElem.data("datapathoverridemodule"),
                    object: overrideElem.data("datapathoverrideobject"),
                    field: overrideElem.data("datapathoverridefield")
                };

                var deferred;
                if (override.field)
                {
                    deferred = $.Deferred().resolve(override);
                }
                else if (dmseParent.length > 0)
                {
                    var dmseModule = dmseParent.data().module;
                    var dmseObject = dmseParent.data().object;
                    var dmseField = dmseParent.data().distinctField;
                    if (dmseField == null)
                    {
                        dmseField = dmseObject + "ID";
                    }

                    var data = $.extend({ fieldName: dmseField }, postData);
                    deferred = $.post(skyward.global.virtualDir + dmseModule + '/' + dmseObject + '/GetF2FieldInfo', data);
                }
                else
                {
                    var strippedFieldName = (elem.parent().is(".tileViewEEL") ? elem[0].name.split("_")[1] : elem[0].name.split("_")[0]);
                    var data = $.extend({ fieldName: strippedFieldName }, postData);
                    deferred = $.post(skyward.global.virtualDir + module + '/' + object + '/GetF2FieldInfo', data);
                }

                deferred.done(function (result)
                {
                    if (elem.hasClass("datepicker"))
                    {
                        elem.datepicker("hide");
                    }
                    if (!result.field)
                    {
                        return;
                    }
                    var label = $(overrideElem).siblings("label.title").contents(":empty").text() || result.field;
                    var data = $.extend({}, { module: module, object: object, label: label, elem: elem }, result);
                    showDataPathPopup(data);
                });
            };
        };

        /**
         * Display a popup with the data path for a given field.
         * @param {object} data Object holding named arguments for the popup
         */
        var showDataPathPopup = function (data)
        {
            var content = $("<div class='informationPopup'>").append([
                createRow("Module", data.module),
                createRow("Object", data.object),
                createRow("Field", data.field),
                createRow("Type", data.type),
                createRow("Default Value", data.defaultValue)
            ]);
            var options =
            {
                anchorTo: data.elem,
                id: "dataPathPopup"
            };
            skyward.modalLayer.showInformationDialog(data.label + " Data Path", content, null, options);

            function createRow(name, value)
            {
                var titleSpan = $("<span class='boldFont'>").text(name + ": ");
                var valueSpan = $("<span>").text(value);
                return $("<div class='datapathPopupRow'>").append([titleSpan, valueSpan]);
            }
        };

        $(function ()
        {
            var securityPathIsOpen = false;
            var pathResponses = skyward.extensions.createCache(function (pathData)
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + "SkySys/ModulePath/Screen",
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        module: pathData.module,
                        object: pathData.object,
                        screen: pathData.screen,
                        secondaryId: pathData.secondaryId,
                        secondaryUrl: pathData.secondaryUrl,
                        secondaryLabelPrefix: pathData.secondaryLabelPrefix
                    }
                });
            });

            $(document.body).on("keydown.altF3Listener", function (event)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                if (!eventKeys.ALT || !eventKeys.F3 || securityPathIsOpen)
                {
                    return;
                }

                securityPathIsOpen = true;
                var currentPath = $("#master,.workflow.skywardContentPanel,.secondaryLocationData").last();
                var options = { beforeClose: function () { securityPathIsOpen = false; } };
                var dialogContainer;

                var content = pathResponses(currentPath.data())
                .then(function (popupHtml)
                {
                    var popup = $(popupHtml);

                    if (currentPath.find(".js-fieldRestrictionMarker").length > 0)
                    {
                        popup.append(createFieldRestrictionSection());
                    }

                    var showSqlButton = popup.data("canViewBrowseSql");
                    var browseNames = Object.keys(skyward.browse.browseList);
                    var browseSections =
                        browseNames
                        .filter(function (name) { return document.getElementById(name); })
                        .map(function (name) { return createBrowseSection(name, showSqlButton); });

                    return popup.append(browseSections);
                });
                dialogContainer = skyward.modalLayer.showInformationDialog("Security Location", content, null, options).container;

                var svgDefinition =
                    "<svg xmlns='http://www.w3.org/2000/svg' class='svgNoHover datapathPopupRow__browseHighlight'>" +
                        "<defs>" +
                            "<mask id='cutout'>" +
                                "<rect x='0' y='0' width='100%' height='100%' fill='white' />" +
                                "<rect class='cutoutRect' fill='black' />" +
                            "</mask>" +
                        "</defs>" +
                        "<rect x='0' y='0' width='100%' height='100%' fill='rgba(0,0,0,0.4)' mask='url(#cutout)' />" +
                    "</svg>";
                var marker = $(new DOMParser().parseFromString(svgDefinition, "text/xml").childNodes[0]);
                var maskRect = marker.find(".cutoutRect");

                var currentScrollParent;
                var scrollParentDimensions;

                function createFieldRestrictionSection()
                {
                    var label = $("<span>", { class: "boldFont", text: "Customized Screen: " });
                    var checkbox = $("<input>", { type: "checkbox", style: "margin: 0px; padding: 0px", checked: "checked" });
                    var fieldRestrictionMark = $("<span>", { text: "***" });

                    skyward.controls.disable(checkbox);

                    return createDataPathRow([label, checkbox, fieldRestrictionMark]);
                }

                function createBrowseSection(browseName, showSqlButton)
                {
                    var browseData = skyward.browse.browseList[browseName];
                    var stats = skyward.browse.getBrowseStats(browseName);

                    var browseDebugName = skyward.browse.getDebugName(browseData);

                    let detailsURL = `${skyward.global.virtualDir}/SkySys/Browse/Details/${browseData.browseId}`

                    var browseParagraphs = [$("<p>", { addClass: "boldFont datapathPopupRow__text", text: browseDebugName })];

                    if (browseData.browseId != null && browseData.browseId >= 0)
                    {
                        browseParagraphs.push($("<a>", { addClass: "boldFont datapathPopupRow__text", text: `ID: ${browseData.browseId}, View ID: ${browseData.viewId}`, href: detailsURL }));
                    }

                    if (stats !== undefined)
                    {
                        browseParagraphs = browseParagraphs.concat(Object.keys(stats).map(function (key)
                        {
                            return $("<p>", { addClass: "datapathPopupRow__text", text: key + ": " + stats[key] + "ms" });
                        }));
                    }
                    else
                    {
                        browseParagraphs.push($("<p>", { addClass: "datapathPopupRow__text", text: "No browse load times available." }));
                    }

                    if (showSqlButton)
                    {
                        var viewSqlButton = createButton("Show Query Text", "View").on("click", function () { showSqlPopup(browseDebugName) });
                        browseParagraphs.push($("<p>", { addClass: "datapathPopupRow__text", append: viewSqlButton }));
                    }

                    var browseElement = browseData.browse[0];

                    var section = createDataPathRow(browseParagraphs)
                        .on("mouseenter", highlightBrowse)
                        .on("mouseleave", endHighlight);

                    return section;

                    function showSqlPopup(title)
                    {
                        var sqlPopupPromise = skyward.browse.getSql(browseName).then(function (sqlText)
                        {
                            var textarea = $("<textarea>",
                            {
                                attr: { readonly: "" },
                                css: { width: "80vw", height: "60vh" },
                                text: sqlText
                            });
                            var copySqlButton = createButton("Copy Query Text", "ClipboardPencil").on("click", function () { copyText(sqlText); });
                            return [textarea, copySqlButton];
                        });
                        var dialog = skyward.modalLayer.showInformationDialog(title, sqlPopupPromise);
                        dialog.content.addClass("datapathPopup__browseSql");
                    }

                    function copyText(text)
                    {
                        // If we use the existing textarea, we can't clear the selection without affecting its scroll position
                        var tempTextArea = $("<textarea>",
                        {
                            css: { width: 0, height: 0, position: "fixed" },
                            text: text
                        });
                        tempTextArea.appendTo(document.body);
                        skyward.dialogFocusManager.toggleIgnoreElement(tempTextArea, true);
                        tempTextArea.focus();
                        tempTextArea.select();
                        document.execCommand("copy");
                        tempTextArea.remove();
                    }

                    function highlightBrowse()
                    {
                        var jqBrowse = $(browseElement);
                        currentScrollParent = jqBrowse.closest(":scrollable");
                        if (currentScrollParent.length)
                        {
                            scrollParentDimensions = currentScrollParent[0].getBoundingClientRect();
                            jqBrowse.scrollintoview();
                            addMarkerScrollCallback(browseElement);
                        }
                        else
                        {
                            scrollParentDimensions = { left: -Infinity, right: Infinity, top: -Infinity, bottom: Infinity };
                        }
                        updateMarkerPosition(browseElement);
                        dialogContainer.before(marker);
                    }

                    function endHighlight()
                    {
                        currentScrollParent.stop();
                        marker.remove();
                    }
                }

                function createDataPathRow(content)
                {
                    return $("<div>",
                    {
                        class: "datapathPopupRow",
                        append: content
                    });
                }

                function createButton(text, svgName)
                {
                    return $("<a>",
                    {
                        addClass: "button chromeless toolbarButton svgAnchor",
                        attr: { href: "#", alt: text },
                        append: [
                            skyward.svg.getSvg(svgName),
                            $("<span>", { class: "buttonNameLabel", text: text })
                        ]
                    });
                }

                function updateMarkerPosition(browseElement)
                {
                    var dimensions = browseElement.getBoundingClientRect();
                    var left = Math.max(dimensions.left, scrollParentDimensions.left);
                    var top = Math.max(dimensions.top, scrollParentDimensions.top);
                    var right = Math.min(dimensions.right, scrollParentDimensions.right);
                    var bottom = Math.min(dimensions.bottom, scrollParentDimensions.bottom);
                    // Prevent Safari complaining about negative width/height
                    maskRect.attr({ x: left, y: top, width: Math.max(right - left, 0), height: Math.max(bottom - top, 0) });
                }

                // $.scrollintoview() doesn't allow us to pass in animation callbacks, so we have to add them by hand
                function addMarkerScrollCallback(browseElement)
                {
                    var timer = $.timers.find(function (timer) { return timer.queue === "scrollintoview" && timer.elem === currentScrollParent[0]; });
                    if (timer)
                    {
                        timer.anim.progress(function () { updateMarkerPosition(browseElement); });
                    }
                }
            });
        });

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);